module.exports = __webpack_public_path__ + "img/sound.7c603406.jpg";